import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import AppRoutes from './Routes';

const container = document.getElementById('app'); // The element ID should match your HTML
const root = createRoot(container); // Create a root.

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </React.StrictMode>,
);

// Fade out the first-load splash (painted in index.html before this bundle ran)
// once the app has mounted, but keep it on screen for a short minimum so it
// reads as an intentional intro rather than a flash.
const MIN_SPLASH_MS = 1500;
const FADE_MS = 600;
const splash = document.getElementById('app-splash');
if (splash) {
  const start = Number(splash.dataset.start) || Date.now();
  const elapsed = Date.now() - start;
  const wait = Math.max(0, MIN_SPLASH_MS - elapsed);
  window.setTimeout(() => {
    splash.classList.add('app-splash--hidden');
    window.setTimeout(() => splash.remove(), FADE_MS);
  }, wait);
}
